function get(fetch) {
    try {
        return fetch();
    }
    catch (_a) {
        return undefined;
    }
}
const _EXPOSED_DEPENDENCIES = get(() => {
    return EXPOSED_DEPENDENCIES;
});
export { _EXPOSED_DEPENDENCIES as EXPOSED_DEPENDENCIES };
const _WEB_COMPONENT_NAME = get(() => {
    return WEB_COMPONENT_NAME;
});
export { _WEB_COMPONENT_NAME as WEB_COMPONENT_NAME };
//# sourceMappingURL=globals.js.map